import React from "react";
import { useHistory } from "react-router-dom";
import Apply from "./img/borrowers_apply.png";
import HomeHeader from "./Headesr";
import NewHomepageFooter from "./NewHomepageFooter";
import "./MarketingRebrand.css";

const contactMethods = [
  {
    icon: "✉",
    title: "Email support",
    description: "support@smart-lend.com",
    action: "Email us",
    href: "mailto:support@smart-lend.com",
  },
  {
    icon: "↗",
    tone: "pink",
    title: "Partner enquiries",
    description: "Speak with us about lender onboarding and platform workflow.",
    action: "Partner with us",
    path: "/partner-with-us",
  },
  {
    icon: "?",
    tone: "green",
    title: "FAQ first",
    description: "Borrowers can quickly resolve application, account, and offer questions.",
    action: "View FAQ",
    path: "/frequentlyaskedquestions",
  },
];

const ContactUs = () => {
  const history = useHistory();

  const go = (path) => {
    history.push(path);
    window.scrollTo(0, 0);
  };

  return (
    <div className="slMarketingPage">
      <HomeHeader />
      <main className="slMarketingShell">
        <div className="slMarketingFrame">
          <section className="slMarketingHero">
            <div className="slMarketingHeroCopy">
              <div className="slEyebrow"><span className="slEyebrowDot" />Contact SmartLend</div>
              <h1>Talk to the team behind the lending workflow.</h1>
              <p className="slLead">
                A clearer contact page that routes borrowers, lenders, partners,
                and support questions without making users hunt for the next step.
              </p>
              <div className="slActions">
                <a className="slBtn slBtnPrimary" href="mailto:support@smart-lend.com">
                  Send message
                </a>
                <button className="slBtn" type="button" onClick={() => go("/frequentlyaskedquestions")}>
                  View FAQ
                </button>
              </div>
            </div>
            <div className="slMarketingMedia">
              <img src={Apply} alt="SmartLend support" />
              <div className="slMediaCaption">
                <b>Support-first layout</b>
                <p>Contact options and support paths sit in one clear, scannable flow.</p>
              </div>
            </div>
          </section>

          <section className="slSection slGrid slGrid2">
            <div className="slCard" style={{ alignSelf: "start" }}>
              <div className="slSectionHead">
                <div>
                  <h2>Send us a message</h2>
                  <p>Use the most direct channel for your request so the right SmartLend team can follow up.</p>
                </div>
              </div>
              <div className="slFormGrid">
                <div className="slField">
                  <label>Support email</label>
                  <input value="support@smart-lend.com" readOnly />
                </div>
                <div className="slField">
                  <label>WhatsApp support</label>
                  <input value="+65 8785 3373" readOnly />
                </div>
                <div className="slActions">
                  <a className="slBtn slBtnPrimary" href="mailto:support@smart-lend.com">
                    Email support
                  </a>
                  <a className="slBtn" href="https://wa.me/6587853373" target="_blank" rel="noreferrer">
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>

            <div className="slGrid">
              {contactMethods.map((item) => (
                <article className="slCard" key={item.title}>
                  <div className={`slIcon ${item.tone === "pink" ? "slIconPink" : item.tone === "green" ? "slIconGreen" : ""}`}>{item.icon}</div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                  {item.href ? (
                    <a className="slBtn" style={{ marginTop: 14 }} href={item.href}>
                      {item.action}
                    </a>
                  ) : (
                    <button className="slBtn" style={{ marginTop: 14 }} type="button" onClick={() => go(item.path)}>
                      {item.action}
                    </button>
                  )}
                </article>
              ))}
              <article className="slCard slCardSoft">
                <h3>Careers</h3>
                <p>
                  There are no current hiring positions available. Keep an eye on
                  SmartLend updates for future openings.
                </p>
              </article>
            </div>
          </section>
        </div>
      </main>
      <NewHomepageFooter />
    </div>
  );
};

export default ContactUs;
